<div class="notification-item {{ item.type }}">
	<h1>
		@if (item.type === 'success') {
			<mat-icon svgIcon="acies_true"></mat-icon>
		}
		@if (item.type === 'error') {
			<mat-icon svgIcon="acies_false"></mat-icon>
		}
		<span>{{ item.heading }}</span>
		<span class="date">{{ formattedDate }} &ndash; {{ formattedTime }}</span>
	</h1>
	<h2>{{ item.text }}</h2>
	<div class="account-info">{{ item.account.organization.name }} > {{ item.account.name }}</div>
	<div class="close" (click)="removeNotification(index)">
		<mat-icon svgIcon="acies_false"></mat-icon>
	</div>
</div>
